// Pickup availability. store_availabilities is only populated on variant-scoped
// requests, so the initial page render can't show it: fetch the API-only
// "pickup-availability" section for the current variant (Section Rendering API)
// and inject its markup into the [data-pickup] wrapper that sections/product.liquid
// renders. Re-fetches when the variant select changes. Styling for the injected
// markup lives in the product section's stylesheet (per-file CSS subsetting).
// Zero dependencies, deferred.
(() => {
  const wrap = document.querySelector('[data-pickup]');
  if (!wrap) return;

  let base = wrap.dataset.baseUrl || '/';
  if (!base.endsWith('/')) base += '/';

  const load = (variantId) => {
    if (!variantId) return;
    fetch(`${base}variants/${variantId}/?section_id=pickup-availability`)
      .then((res) => (res.ok ? res.text() : Promise.reject()))
      .then((html) => {
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) wrap.replaceChildren(...section.children);
      })
      .catch(() => {});
  };

  load(wrap.dataset.variantId);

  // The variant picker is a native <select name="id"> inside the product root.
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el && el.name === 'id' && el.closest('[data-product-root]')) load(el.value);
  });
})();
